/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between characters with and without spaces?`)
};

const es_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre caracteres con y sin espacios?`)
};

const de_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen Zeichen mit und ohne Leerzeichen?`)
};

const nl_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen tekens met en zonder spaties?`)
};

const fr_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre les caractères avec et sans espaces ?`)
};

const it_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra caratteri con e senza spazi?`)
};

const pt_br2_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre caracteres com e sem espaços?`)
};

const pt_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre caracteres com e sem espaços?`)
};

const ja_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペース付きとスペースなしの文字数の違いは何ですか？`)
};

const zh_wc_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含空格字符数和不含空格字符数有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_faq2_q", locale)
	if (locale === "en") return en_wc_faq2_q(inputs)
	if (locale === "es") return es_wc_faq2_q(inputs)
	if (locale === "de") return de_wc_faq2_q(inputs)
	if (locale === "nl") return nl_wc_faq2_q(inputs)
	if (locale === "fr") return fr_wc_faq2_q(inputs)
	if (locale === "it") return it_wc_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wc_faq2_q(inputs)
	if (locale === "pt") return pt_wc_faq2_q(inputs)
	if (locale === "ja") return ja_wc_faq2_q(inputs)
	return zh_wc_faq2_q(inputs)
};